import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Autocomplete, Chip } from '@mui/material';
import { GetOrgUsers } from '../../../../api';

export default function NewConversationDialog({ open, onClose, onCreate, access, user }) {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [groupName, setGroupName] = useState('');

  const loadUsers = useCallback(async () => {
    if (!access?.org?.id) {
      console.error('No organization ID available');
      setUsers([]);
      return;
    }
    try {
      const data = await GetOrgUsers(access.org.id);
      const currentUserId = user?.id;
      const filteredUsers = (data || []).filter(u => u?.id && u.id !== currentUserId && !u.settings?.disableChat);
      setUsers(filteredUsers);
    } catch (err) {
      console.error('Failed to load users:', err);
      setUsers([]);
    }
  }, [access?.org?.id, user?.id]);

  useEffect(() => {
    if (open) {
      loadUsers();
    }
  }, [open, loadUsers]);

  const handleCreate = () => {
    if (!selectedUsers || selectedUsers.length === 0) {
      alert('Please select at least one participant.');
      return;
    }
    
    const participantIds = selectedUsers.map(u => u?.id).filter(Boolean);
    if (participantIds.length === 0) {
      alert('Invalid participants selected.');
      return;
    }
    
    const isGroupChat = selectedUsers.length > 1;
    const name = isGroupChat && groupName?.trim() ? groupName.trim() : null;
    
    onCreate(participantIds, isGroupChat, name);
    
    setSelectedUsers([]);
    setGroupName('');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>New Conversation</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          options={users}
          getOptionLabel={(option) => option.name || option.email}
          value={selectedUsers}
          onChange={(e, newValue) => setSelectedUsers(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Select participants" margin="normal" />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const { key, ...chipProps } = getTagProps({ index });
              return (
                <Chip key={key} label={option.name || option.email} {...chipProps} />
              );
            })
          }
        />
        
        {selectedUsers.length > 1 && (
          <TextField
            fullWidth
            label="Group Name (optional)"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            margin="normal"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleCreate} variant="contained" disabled={selectedUsers.length === 0}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
